'use client';

import { useEffect } from 'react';
import { trackInteraction } from './trackInteraction';
import { trackWebsiteClick } from './trackWebsiteClick';

const INTERACTIVE_SELECTOR = [
  'button',
  '[role="button"]',
  '[role="tab"]',
  '[role="switch"]',
  '[role="radio"]',
  'input[type="checkbox"]',
  'input[type="radio"]',
  'input[type="range"]',
  'select',
  'summary',
  '[class*="cursor-pointer"]',
  '[data-track]',
].join(', ');

export default function WebsiteClickTracker() {
  useEffect(() => {
    function handleClick(e: MouseEvent) {
      const target = e.target as HTMLElement;

      // Anchors keep their existing dedicated `website_click` event.
      const anchor = target.closest('a');
      if (anchor?.href) {
        trackWebsiteClick(anchor);
        return;
      }

      // Everything else (buttons, tabs, toggles, accordions, …) becomes a
      // `website_interaction` event attributed to its module.
      const interactive = target.closest<HTMLElement>(INTERACTIVE_SELECTOR);
      if (interactive) {
        trackInteraction(interactive);
      }
    }

    document.addEventListener('click', handleClick, { capture: true });
    return () => document.removeEventListener('click', handleClick, { capture: true });
  }, []);

  return null;
}
